import { Component, Input } from "@angular/core";
import './trailer.component.scss';

@Component({
    selector: 'trailer',
    template: require('./trailer.component.html')
})
export class TrailerComponent {
    @Input() reeferMake: string;
    @Input() maxWidth: number = 1000;

    constructor() { }


}
